import React from 'react';
import bgimage from '../../Media/Images/home_three.jpg';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BasicSlider.css';
import playstore from './google-play.png';
import appstore from './app.png';
import { useUser } from '../../UserContext';

const BasicSlider = () => {
	const navigate = useNavigate();
	const { user } = useUser();
	const [isExpanded, setIsExpanded] = useState(false);

	const handleToggle = () => {
		setIsExpanded((prevState) => !prevState);
	};

	return (
		<div
			className='flex items-center lg:items-start justify-center bg-gradient-to-br from-[#022c56] via-[#034068] to-[#045580] relative overflow-hidden lg:pt-[52px] lg:pb-[52px] pb-8'
			style={{ marginTop: 'var(--header-height)' }}
		>
			{/* Background pattern/overlay */}
			<div className='absolute inset-0 bg-black/10'></div>

			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10'>
				<div className='grid lg:grid-cols-2 gap-12 lg:items-start items-center'>
					{/* Content Section */}
					<div className='text-center lg:text-left pt-20 lg:pt-12 space-y-6 lg:space-y-8'>
						<div className='space-y-6'>
							<h1 className='text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight'>
								Be Yourself a <span className='text-yellow-400'>Reporter</span>
							</h1>
							<h2 className='text-2xl lg:text-3xl font-semibold text-blue-200'>
								With My News, My Report
								<br />
								from
								<br />
								B-Reporter
							</h2>
						</div>

						<div className='max-w-3xl'>
							{!isExpanded && (
								<p className='text-lg text-blue-100 leading-relaxed'>
									Uncertain about the Place, Time and Source (PTS) of a news floating over social media? Confused with
									agenda based paid, fake news or fact checks? B-Reporter brings{' '}
									<span className='font-semibold text-yellow-300'>location-aware</span> and{' '}
									<span className='font-semibold text-yellow-300'>scene-aware</span> social media platform – My News, My
									Report...
									<button
										onClick={handleToggle}
										className='ml-2 text-yellow-400 hover:text-yellow-300 underline font-medium transition-colors duration-200'
									>
										Read more
									</button>
								</p>
							)}
							{isExpanded && (
								<p className='text-lg text-blue-100 leading-relaxed'>
									Uncertain about the Place, Time and Source (PTS) of a news floating over social media? Confused with
									agenda based paid, fake news or fact checks? B-Reporter brings{' '}
									<span className='font-semibold text-yellow-300'>location-aware</span> and{' '}
									<span className='font-semibold text-yellow-300'>scene-aware</span> social media platform – My News, My
									Report. It works on the principle of live record and report, thus avoiding post-facto and helping the
									reporter timely if required/possible. Not allowing Photoshop and uploading, maintains the sanctity of
									the report. Bringing ground report from people on ground will further add to the authenticity. <br />
									<br />
									<span className='font-semibold text-yellow-300'>Multimodality</span> gives further flexibility in
									timely reporting before getting victimized. We are committed to connect victim to the authority for
									instant help, to eventually become victor. It empowers every individual to remain alert about
									happening in surroundings.
									<button
										onClick={handleToggle}
										className='ml-2 text-yellow-400 hover:text-yellow-300 underline font-medium transition-colors duration-200'
									>
										Read less
									</button>
								</p>
							)}
						</div>

						<div className='flex flex-row justify-center items-center gap-2 sm:gap-6 flex-nowrap'>
							<button
								onClick={() => {
									navigate(user ? '/news' : '/login');
								}}
								className='px-6 custom-get-started bg-yellow-500 hover:bg-yellow-400 text-[#022c56] font-bold text-lg rounded-full transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl'
							>
								Get Started
							</button>

							<a
								href='https://play.google.com/store/apps/details?id=com.iitd.breporter3'
								className='transition-all duration-300 hover:scale-105 hover:drop-shadow-xl outline-none'
							>
								<img src={playstore} width={45} className='transition-shadow' alt='Get on Google Play' />
							</a>

							<a
								href='https://apps.apple.com/in/app/my-news-my-report/id6744141391'
								className='transition-all duration-300 hover:scale-105 hover:drop-shadow-xl outline-none'
							>
								<img src={appstore} width={45} className='transition-shadow' alt='Download on the App Store' />
							</a>
						</div>
					</div>

					{/* Image Section */}
					<div className='hidden lg:flex justify-center lg:justify-end lg:pt-0'>
						<div className='relative'>
							<div className='absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-blue-400/20 rounded-3xl blur-3xl transform rotate-6'></div>
							<img
								src={bgimage}
								className='relative z-10 max-w-full h-auto rounded-3xl shadow-2xl hover:scale-105 transition-transform duration-500'
								width='600'
								alt='B-Reporter App Preview'
							/>
						</div>
					</div>
				</div>
			</div>

			{/* Floating elements for visual appeal */}
			<div className='absolute top-20 left-10 w-20 h-20 bg-yellow-400/10 rounded-full blur-xl'></div>
			<div className='absolute bottom-20 right-10 w-32 h-32 bg-blue-400/10 rounded-full blur-xl'></div>
			<div className='absolute top-1/2 left-1/4 w-16 h-16 bg-white/5 rounded-full blur-lg'></div>
		</div>
	);
};

export default BasicSlider;
